import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import './i18n';

// 清除旧版 localStorage 设计数据缓存（设计数据现在全部存后端）
localStorage.removeItem('sunsim-scene');

// 静默浏览器扩展引起的 message channel 错误
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('message channel closed')) {
    e.preventDefault();
  }
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
